type ArrowType = {
  fill?: string
  title?: string
}

function ArrowDown(props: ArrowType) {
  const fill = props.fill || 'currentColor'
  const title = props.title || 'arrow down'

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='52'
      height='131'
      viewBox='0 0 52 131'
      fill='none'
      className='ml-3xs mt-xs'
    >
      <title>{title}</title>
      <path
        d='M26 1L26 129L26 125.541'
        stroke={fill}
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
      <path
        d='M50 105.667L26 129L2 105.667'
        stroke={fill}
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
    </svg>
  )
}

export default ArrowDown
